import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useContext, useState } from "react";
import { ThemeContext } from "../ThemeContext";
import { useTranslation } from 'react-i18next';
import veridian from "../../assets/veridian.png";


export const Header = () => {
    const [theme, setTheme] = useContext(ThemeContext) as ["light" | "dark", React.Dispatch<React.SetStateAction<"light" | "dark">>];
    const { t, i18n } = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className={theme}> 
           <div className="container">
                <header className="header flex justify-between items-center relative">
                    <div className="max-w-[150px] sm:max-w-[200px] logo">
                        <Link to="/">
                            <img src={veridian} alt="logo" />
                        </Link>
                    </div>
                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex items-center space-x-8">
                        <ul className="flex gap-4 items-center">
                            <li><NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>{t('menu.home')}</NavLink></li>
                            <li><NavLink to="/blog">{t('menu.blog')}</NavLink></li>
                            <li><NavLink to="/contact">{t('menu.contact')}</NavLink></li>
                            <li>
                                <button className="theme-button" onClick={() => setTheme(theme === "light" ? "dark" : "light")}>
                                    {theme === 'light' ? '🌙' : '☀️'}
                                </button>
                            </li>
                            <li>
                                <button className="language-button"
                                    onClick={() => i18n.changeLanguage(i18n.language === 'en' ? 'sk' : 'en')}
                                >
                                    {i18n.language === 'en' ? 'SK' : 'EN'}
                                </button>
                            </li>
                        </ul>
                    </nav>

                    {/* Hamburger Button */}
                    <button 
                        className="md:hidden p-2 cursor-pointer toggle-button"
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <div className={`w-6 h-0.5  dark:bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
                        <div className={`w-6 h-0.5  dark:bg-white mt-1.5 ${isMenuOpen ? 'opacity-0' : ''}`}></div>
                        <div className={`w-6 h-0.5  dark:bg-white mt-1.5 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></div>
                    </button>

                    {/* Mobile Menu */}
                    <div className={`
                        md:hidden 
                        absolute top-full left-0 right-0 
                        bg-white dark:bg-gray-900 
                        shadow-lg 
                        transition-all duration-300 ease-in-out
                        ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
                        z-50
                    `}>
                        <nav className="flex flex-col p-4 toggle-menu">
                            <ul className="flex flex-col gap-4">
                                <li>
                                    <NavLink 
                                        to="/" 
                                        className={({ isActive }) => isActive ? 'active' : ''}
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {t('menu.home')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink 
                                        to="/blog"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {t('menu.blog')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink 
                                        to="/contact"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {t('menu.contact')}
                                    </NavLink>
                                </li>
                                <li className="flex gap-4">
                                    <button 
                                        className="theme-button"
                                        onClick={() => {
                                            setTheme(theme === "light" ? "dark" : "light");
                                            setIsMenuOpen(false);
                                        }}
                                    >
                                        {theme === 'light' ? '🌙' : '☀️'}
                                    </button>
                                    <button 
                                        className="language-button"
                                        onClick={() => {
                                            i18n.changeLanguage(i18n.language === 'en' ? 'sk' : 'en');
                                            setIsMenuOpen(false);
                                        }}
                                    >
                                        {i18n.language === 'en' ? 'SK' : 'EN'}
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </header>
           </div>
        </div>
    );
};
